import { BaseModel } from "@/models/base.model"
import { type IInstructionFeedbackActivityTypeSetting } from "@/interfaces/api/instruction-feedback-activity-type-setting.interface"
import { InstructionFeedbackActivityType } from "@/models/tenant_settings/instruction-feedback-activity-type.model"
import { ModelFactory } from "@/factories/model-factory"

export class InstructionFeedbackActivityTypeSetting
  extends BaseModel
  implements IInstructionFeedbackActivityTypeSetting
{
  public static className = "InstructionFeedbackActivityTypeSetting"

  public static verboseName = "Terugkoppelingsactiviteittype-instelling"

  tenantSettings: string
  activityType: InstructionFeedbackActivityType
  sortIndex: number

  constructor(setting: IInstructionFeedbackActivityTypeSetting, managed = false) {
    super(setting)

    this.tenantSettings = setting.tenantSettings
    this.activityType = ModelFactory.childModel(
      InstructionFeedbackActivityType,
      setting.activityType,
      managed
    )
    this.sortIndex = setting.sortIndex
  }
}
